import React from "react";
import moment from "moment";
import { Button, Drawer, Panel} from "rsuite";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import logo from "../../assets/logo.png";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import { useDispatch, useSelector } from "react-redux";

import Header from "./../../components/Header";
import AdminSideBar from "./../../components/SiderBar";
import AdminCarrosValidation from "./../../components/adminCarrosValidation";

import DrawerLiveracaoAdminx from "../../components/DrawerLiveracaoAdminx";
import ClientesList from "../../components/clientesList";
import CarrosList from "../../components/carrosList";
import VansAdminRegistros from "../../components/vansAdminRegistro";

import {
  allAdmins,
  updateAdmin,
  filterClientes,
  loginSessionAdminIn,
  sessionLogOut,
} from "../../store/modules/admin/actions";
import {
  allClientes,
  updateCliente,
  updateDataCliente,
} from "../../store/modules/cliente/actions";
import { allCarros } from "../../store/modules/reservaCarro/actions";

var tokenAuto = sessionStorage.getItem("token");
var SesId = sessionStorage.getItem("id");
var SesNome = sessionStorage.getItem("name");
var SesEmail = sessionStorage.getItem("email");
var SesAtive = sessionStorage.getItem("active");

export default function AdminDashboard() {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const {
    behavior,
    form,
    components,
    code,
    loginCliente,
    step1,
    step2,
    auth,
    reservations,
    carrosDisponivel,
    carros_Alugados,
    carro_Alugado,
    carro,
    adminDrawer,
    administrador,
    drawer_admin,
    carroAdm,
  } = useSelector((state) => state.admin);

  const { clientes, cliente } = useSelector((state) => state.cliente);
  const { carros } = useSelector((state) => state.reserva);

  const setComponent = (component, state) => {
    dispatch(
      updateAdmin({
        components: { ...components, [component]: state },
      })
    );
  };

  const updateDataClienteSet = (key, value) => {
    dispatch(
      updateCliente({
        cliente: { ...cliente, [key]: value },
      })
    );
  };
  const updateAdminCarro = (key, value) => {
    dispatch(
      updateAdmin({
        carroAdm: { ...carroAdm, [key]: value },
      })
    );
  };

  function restart() {
    dispatch(
      updateAdmin({
        form: { ...form, steps: 1 },
      })
    );
  }

  const setHorario = (key, value) => {
    dispatch(
      updateAdmin({
        reservations: { ...reservations, [key]: value },
      })
    );
  };

  function convertDatePickerTimeToMySQLTime(str) {
    var month, day, year, hours, minutes, seconds;
    var date = new Date(str),
      month = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    hours = ("0" + date.getHours()).slice(-2);
    minutes = ("0" + date.getMinutes()).slice(-2);
    seconds = ("0" + date.getSeconds()).slice(-2);

    var mySQLDate = [date.getFullYear(), month, day].join("-");
    var mySQLTime = [hours, minutes, seconds].join(":");
    return [mySQLDate, mySQLTime].join("T");
  }

  useEffect(() => {
    dispatch(allAdmins());
  }, [reservations.end_date]);

  const logOut = () => {
    dispatch(
      updateAdmin({
        behavior: "admin",
      })
    );
    setComponent("drawer_admin", true);

    dispatch(updateAdmin({ carro }));

    /*
     */
  };

  const formatRange = (periodo) => {
    let finalRange = {};
    if (Array.isArray(periodo)) {
      finalRange = {
        start: moment(periodo[0]).format("YYYY-MM-DD"),
        end: moment(periodo[periodo.length - 1]).format("YYYY-MM-DD"),
      };
    } else {
      finalRange = {
        start: moment(periodo.start).format("YYYY-MM-DD"),
        end: moment(periodo.end).format("YYYY-MM-DD"),
      };
    }

    return finalRange;
  };

  const verCarro = (carro) => {
    dispatch(
      updateAdmin({
        behavior: "Liverar",
      })
    );

    dispatch(
      updateAdmin({
        carro_Alugado: { ...carro },
      })
    );

    setComponent("header", false);
    setComponent("drawer", true);
  };

  useEffect(() => {
    if (window.screen.width >= 1300 && window.screen.height >= 700) {
      dispatch(allClientes());
      dispatch(allCarros());
    }
  }, []);

  return (
    <div
      className=" d-flex flex-column bd-highlight p-0 m-0    col-12 col-sd-12 col-md-12 col-xl-12
      bg-dark  "
    >
      <div
        className=" d-flex  flex-row col-12 col-sd-12 col-md-12 col-xl-12"
        onClick={logOut}
      >
        <Header
          name={SesNome}
          email={SesEmail}
          className=" d-flex  flex-row col-12 col-sd-12 col-md-12 col-xl-12 "
        />
      </div>
      <div className="d-fex flex-column  col-12 col-sd-12 col-md-12 col-xl-12  p-0 m-0">
        {/* Drawer de Clientes */}
        <Drawer
          open={components.drawer}
          size="full"
          placement="top"
          onClose={() => {
            setComponent("drawer", false);
          }}
        >
          <Drawer.Body>
            <h3>
              {behavior === "cliente" ? "Cliente" : "Carro para liverar"}{" "}
            </h3>
            <div className="input-group-append d-flex flex-row  col-12 col-xl-12 align-content-center">
              <Panel className="col-12 col-xl-12 ">
                <div className="form-group col-6">
                  <b>{behavior === "cliente" ? "id do cliente" : ""}</b>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="ID"
                    disabled={true}
                    value={behavior === "cliente" ? cliente.id : ""}
                    onChange={(e) =>
                      behavior === "cliente"
                        ? updateDataClienteSet("id", e.target.value)
                        : ""
                    }
                  />
                </div>
                <div className="form-group col-6">
                  <b>{behavior === "cliente" ? "Nome" : ""}</b>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Nome do cliente"
                    value={behavior === "cliente" ? cliente.name : ""}
                    onChange={(e) =>
                      behavior === "cliente"
                        ? updateDataClienteSet("name", e.target.value)
                        : ""
                    }
                  />
                </div>
                <div className="form-group col-6">
                  <b>{behavior === "cliente" ? "E-mail" : ""}</b>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Email"
                    value={behavior === "cliente" ? cliente.email : ""}
                    onChange={(e) =>
                      behavior === "cliente"
                        ? updateDataClienteSet("email", e.target.value)
                        : ""
                    }
                  />
                </div>
                <div className="form-group col-6">
                  <b>{behavior === "cliente" ? "CPF" : ""}</b>

                  <input
                    disabled={true}
                    type="text"
                    className="form-control"
                    placeholder="Cpf"
                    value={behavior === "cliente" ? cliente.cpf : ""}
                    onChange={(e) =>
                      behavior === "cliente"
                        ? updateDataClienteSet("cpf", e.target.value)
                        : ""
                    }
                  />
                </div>
                <div className="form-group col-6">
                  <b>{behavior === "cliente" ? "Telefone do cliente" : ""}</b>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Telefone"
                    value={behavior === "cliente" ? cliente.phone_number : ""}
                    onChange={(e) =>
                      behavior === "cliente"
                        ? updateDataClienteSet("phone_number", e.target.value)
                        : ""
                    }
                  />
                </div>
                <div className="form-group col-6">
                  <b>{behavior === "cliente" ? "Endereço do cliente" : ""}</b>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Telefone"
                    value={behavior === "cliente" ? cliente.address : ""}
                    onChange={(e) =>
                      behavior === "cliente"
                        ? updateDataClienteSet("address", e.target.value)
                        : ""
                    }
                  />
                </div>
                <div className="form-group col-6">
                  <b>{behavior === "cliente" ? "Numero de endereço" : ""}</b>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Numero"
                    value={behavior === "cliente" ? cliente.address_number : ""}
                    onChange={(e) =>
                      behavior === "cliente"
                        ? updateDataClienteSet("address_number", e.target.value)
                        : ""
                    }
                  />
                </div>
                <div className="form-group col-6">
                  <b>{behavior === "cliente" ? "Complemento" : ""}</b>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Complemento"
                    value={
                      behavior === "cliente" ? cliente.address_complement : ""
                    }
                    onChange={(e) =>
                      behavior === "cliente"
                        ? updateDataClienteSet(
                            "address_complement",
                            e.target.value
                          )
                        : ""
                    }
                  />
                </div>
                <div className="form-group col-6">
                  <b>{behavior === "cliente" ? "Distrito" : ""}</b>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Distrito"
                    value={
                      behavior === "cliente" ? cliente.address_district : ""
                    }
                    onChange={(e) =>
                      behavior === "cliente"
                        ? updateDataClienteSet(
                            "address_district",
                            e.target.value
                          )
                        : ""
                    }
                  />
                </div>
                <div className="form-group col-6">
                  <b>{behavior === "cliente" ? "Ciudade" : ""}</b>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ciudade"
                    value={behavior === "cliente" ? cliente.address_city : ""}
                    onChange={(e) =>
                      behavior === "cliente"
                        ? updateDataClienteSet("address_city", e.target.value)
                        : ""
                    }
                  />
                </div>
                <div className="form-group col-6">
                  <b>{behavior === "cliente" ? "Estado" : ""}</b>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Estado"
                    value={behavior === "cliente" ? cliente.address_state : ""}
                    onChange={(e) =>
                      behavior === "cliente"
                        ? updateDataClienteSet("address_state", e.target.value)
                        : ""
                    }
                  />
                </div>
                <div className="form-group col-6">
                  <b>{behavior === "cliente" ? "Cep" : ""}</b>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Codigo Postal"
                    value={
                      behavior === "cliente" ? cliente.address_zipcode : ""
                    }
                    onChange={(e) =>
                      behavior === "cliente"
                        ? updateDataClienteSet(
                            "address_zipcode",
                            e.target.value
                          )
                        : ""
                    }
                  />
                </div>
                <div className="form-group col-6">
                  <b>{behavior === "cliente" ? "Ativo?" : ""}</b>
                  <input
                    type="text"
                    className="form-control"
                    placeholder={cliente.active ? "Ativo" : "Não ativo"}
                    value={cliente.active ? "Ativo" : "NÃO Ativo"}
                    onChange={(e) =>
                      behavior === "cliente"
                        ? updateDataClienteSet("active", e.target.value)
                        : ""
                    }
                  />
                </div>

                <div className=" col-12 text-center size-sm "></div>
              </Panel>
            </div>

            <Button
              block
              appearance="primary"
              className=" mt-3"
              color={behavior === "cliente" ? "green" : "blue"}
              size="lg"
              loading={form.saving}
              onClick={() => {
                dispatch(updateDataCliente());
              }}
            >
              {behavior === "cliente" ? "Update CLiente " : ""}
            </Button>
            <Button
              block
              appearance="primary"
              className=" mt-3"
              color="blue"
              size="lg"
              loading={form.saving}
              onClick={() => {
                setComponent("drawer", false);
              }}
            >
              voltar
            </Button>
          </Drawer.Body>
        </Drawer>

        {/* Drawer de carros */}
        <Drawer
          open={components.drawer_carros}
          size="full"
          placement="top"
          onClose={() => {
            setComponent("drawer_carros", false);
          }}
        >
          {behavior === "carro" ? (
            <Drawer.Body>
              <h3>
                {behavior === "carro"
                  ? "Visualizar carro:"
                  : "Cadastrar carro:"}
              </h3>
              <div className="input-group-append d-flex flex-row  col-12 col-xl-12 align-content-center">
                <Panel className="col-6 col-xl-6 ">
                  <div className="form-group col-6">
                    <b>Carro id: </b>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="ID"
                      disabled={behavior === "carro" ? true : false}
                      value={behavior === "carro" ? carro.id : ""}
                      onChange={(e) =>
                        behavior === "carro"
                          ? updateDataClienteSet("id", e.target.value)
                          : ""
                      }
                    />
                  </div>
                  <div className="form-group col-6">
                    <b>Marca: </b>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="Marca"
                      disabled={false}
                      value={
                        behavior === "carro"
                          ? carro.brand
                            ? carro.brand.name
                            : ""
                          : ""
                      }
                      onChange={(e) =>
                        behavior === "carro"
                          ? updateDataClienteSet("id", e.target.value)
                          : ""
                      }
                    />
                  </div>
                  <div className="form-group col-6">
                    <b>Modelo: </b>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="Modelo"
                      disabled={false}
                      value={behavior === "carro" ? carro.model : ""}
                      onChange={(e) =>
                        behavior === "carro"
                          ? updateDataClienteSet("id", e.target.value)
                          : ""
                      }
                    />
                  </div>
                  <div className="form-group col-6">
                    <b>Placa: </b>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="Placa"
                      disabled={false}
                      value={behavior === "carro" ? carro.license : ""}
                      onChange={(e) =>
                        behavior === "carro"
                          ? updateDataClienteSet("id", e.target.value)
                          : ""
                      }
                    />
                  </div>
                  <div className="form-group col-6">
                    <b>km rodado: </b>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="km rodado"
                      disabled={false}
                      value={behavior === "carro" ? carro.odometer : ""}
                      onChange={(e) =>
                        behavior === "carro"
                          ? updateDataClienteSet("id", e.target.value)
                          : ""
                      }
                    />
                  </div>
                  <div className="form-group col-6">
                    <b>Estado: </b>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="A"
                      disabled={false}
                      value={behavior === "carro" ? carro.status : ""}
                      onChange={(e) =>
                        behavior === "carro"
                          ? updateDataClienteSet("id", e.target.value)
                          : ""
                      }
                    />
                  </div>
                  <div className="col-6">
                    <Button
                      block
                      appearance="primary "
                      className=" mt-3 "
                      color={behavior === "carro" ? "green" : "green"}
                      size="lg"
                      loading={form.saving}
                      onClick={() => {
                        dispatch(updateDataCliente());
                      }}
                    >
                      {behavior === "carro" ? "Update carro " : "Criar carro"}
                    </Button>
                    <Button
                      block
                      appearance="primary"
                      className=" mt-3"
                      color="blue"
                      size="lg"
                      loading={form.saving}
                      onClick={() => {
                        setComponent("drawer_carros", false);
                      }}
                    >
                      voltar
                    </Button>
                  </div>
                </Panel>
                <div className="d-fle align-items-start justify-content-start">
                  <img
                    src={carro.photo != null ? carro.photo : logo}
                    height="240"
                  />
                </div>
              </div>
            </Drawer.Body>
          ) : (
            <Drawer.Body>
              <h3>
                {behavior === "carro"
                  ? "Visualizar carro:"
                  : "Cadastrar carro:"}
              </h3>
              <div className="input-group-append d-flex flex-row  col-12 col-xl-12 align-content-center">
                <Panel className="col-6 col-xl-6 ">
                  <div className="form-group col-6">
                    <b>license: </b>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="license"
                      disabled={false}
                      value={carroAdm.license}
                      onChange={(e) =>
                        updateAdminCarro("license", e.target.value)
                      }
                    />
                  </div>
                  <div className="form-group col-6">
                    <b>model: </b>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="model"
                      disabled={false}
                      value={carroAdm.model}
                      onChange={(e) =>
                        updateAdminCarro("model", e.target.value)
                      }
                    />
                  </div>
                  <div className="form-group col-6">
                    <b>odometer: </b>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="odometer"
                      disabled={false}
                      value={carroAdm.odometer}
                      onChange={(e) =>
                        updateAdminCarro("odometer", e.target.value)
                      }
                    />
                  </div>
                  <div className="form-group col-6">
                    <b>consumption: </b>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="consumption"
                      disabled={false}
                      value={carroAdm.consumption}
                      onChange={(e) =>
                        updateAdminCarro("consumption", e.target.value)
                      }
                    />
                  </div>
                  <div className="form-group col-6">
                    <b>active: </b>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="km rodado"
                      disabled={false}
                      value={carroAdm.active}
                      onChange={(e) =>
                        updateAdminCarro("active", e.target.value)
                      }
                    />
                  </div>
                  <div className="form-group col-6">
                    <b>brands_id: </b>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="1"
                      disabled={false}
                      value={carroAdm.brands_id}
                      onChange={(e) =>
                        updateAdminCarro("brands_id", e.target.value)
                      }
                    />
                  </div>
                  <div className="form-group col-6">
                    <b>status: </b>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="A"
                      disabled={false}
                      value={carroAdm.status}
                      onChange={(e) =>
                        updateAdminCarro("status", e.target.value)
                      }
                    />
                  </div>
                  <div>
                    <b>Frente do Carro</b>
                    <input
                      type="file"
                      accept="image/png, image/gif, image/jpeg"
                      capture="camera"
                      value={carroAdm.photo}
                      onChange={(e) =>
                        updateAdminCarro("photo", e.target.value)
                      }
                    />
                  </div>

                  <div className="col-6">
                    <Button
                      block
                      appearance="primary "
                      className=" mt-3 "
                      color={behavior === "carro" ? "green" : "green"}
                      size="lg"
                      loading={form.saving}
                      onClick={() => {
                        dispatch(updateDataCliente());
                      }}
                    >
                      {behavior === "carro" ? "Update carro " : "Criar carro"}
                    </Button>
                    <Button
                      block
                      appearance="primary"
                      className=" mt-3"
                      color="blue"
                      size="lg"
                      loading={form.saving}
                      onClick={() => {
                        setComponent("drawer_carros", false);
                      }}
                    >
                      voltar
                    </Button>
                  </div>
                </Panel>
                <div className="d-fle align-items-start justify-content-start">
                  <img
                    src={carroAdm.photo != null ? carroAdm.photo : logo}
                    height="240"
                  />
                </div>
              </div>
            </Drawer.Body>
          )}
        </Drawer>

        {/* Drawer de admin */}
        <Drawer
          open={components.drawer_admin}
          size="full"
          placement="top"
          onClose={() => {
            setComponent("drawer_admin", false);
          }}
        >
          <Drawer.Body>
            <h3>
              {behavior === "admin" ? "Visualizar Admin:" : "Cadastrar carro:"}
            </h3>
            <div className="input-group-append d-flex flex-row  col-12 col-xl-12 align-content-center">
              <Panel className="col-6 col-xl-6 ">
                <div className="form-group col-6">
                  <b>Admin id: </b>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="ID"
                    disabled={true}
                    value={SesNome}
                  />
                </div>
                <div className="form-group col-6">
                  <b>Admin email: </b>

                  <input
                    type="text"
                    className="form-control"
                    placeholder="ID"
                    disabled={true}
                    value={SesEmail}
                  />
                </div>

                <div className="col-6">
                  <Button
                    block
                    appearance="primary "
                    className=" mt-3 "
                    color={behavior === "admin" ? "red" : "green"}
                    size="lg"
                    loading={form.saving}
                    onClick={() => {
                      sessionStorage.removeItem("token");
                      dispatch(sessionLogOut());
                      navigate("/");
                    }}
                  >
                    {behavior === "admin" ? "Sair " : "Criar Admin"}
                  </Button>
                  <Button
                    block
                    appearance="primary"
                    className=" mt-3"
                    color="blue"
                    size="lg"
                    loading={form.saving}
                    onClick={() => {
                      setComponent("drawer_admin", false);
                    }}
                  >
                    voltar
                  </Button>
                </div>
              </Panel>
              <div className="d-fle align-items-start justify-content-start">
                <img
                  src={carro.photo != null ? carro.photo : logo}
                  height="240"
                />
              </div>
            </div>
          </Drawer.Body>
        </Drawer>
      </div>

      {window.screen.width >= 1300 && window.screen.height >= 700 ? (
        <div className=" d-flex  flex-row col-10 col-sd-12 col-md-12 col-xl-11 p-0 m-0 h-100 ">
          <div className=" d-flex  flex-row col-xl-1 justify-content-center  ">
            <AdminSideBar className="d-flex flex-row justify-content-center align-items-center " />
          </div>

          {behavior === "Calendary" && <DrawerLiveracaoAdminx />}

          {behavior === "clientesList" && <ClientesList />}

          {behavior === "carros" && <CarrosList />}

          {behavior === "admins" && <h1>admins</h1>}

          {behavior === "Vans" && <VansAdminRegistros/>}
        </div>
      ) : (
        <div className=" d-fex flex-column  col-12 col-sd-12 col-md-12 col-xl-12  p-0">
          <AdminCarrosValidation className="d-fex flex-column col-12 col-sd-12 col-md-12 col-xl-12" />
        </div>
      )}
   
    </div>
  );
}
